import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import ErrorBoundary, { reportarError } from './components/ErrorBoundary/ErrorBoundary';
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Errores asíncronos que no pasan por React (promesas sin catch)
window.addEventListener('unhandledrejection', (e) => reportarError(e.reason));

reportWebVitals();
